import { createHooks } from '@wordpress/hooks';

const hooks = createHooks();

// Hack: WP's hooks implementation has a bug where the 'all' hook handlers are
// added multiple times to the list of handlers to call for any hook. Until
// this bug is fixed, we'll fix it ourselves with this hack. See
// https://github.com/WordPress/gutenberg/blob/f07e7560456dc364e306a01d5e6ba6bc47523649/packages/hooks/src/createRunHook.js#L37
// WP's implementation should be modifying a copy of `handlers`, but it always
// keeps pushing more and more copies of a function to `handlers`.

function actionHandler( ...args ) {
  const hookName = hooks.currentAction();

  if ( hookName !== 'all' ) {
    // Remove the `all` handlers. WP's (currently buggy) implementation will add them back in.
    hooks.actions[ hookName ].handlers = hooks.actions[ hookName ].handlers.filter( handler => hooks.actions.all.handlers.indexOf( handler ) === -1 );
  }
}

function filterHandler( ...args ) {
  const hookName = hooks.currentFilter();

  if ( hookName !== 'all' ) {
    // Remove the `all` handlers. WP's (currently buggy) implementation will add them back in.
    hooks.filters[ hookName ].handlers = hooks.filters[ hookName ].handlers.filter( handler => hooks.filters.all.handlers.indexOf( handler ) === -1 );
  }

  return args[ 0 ];
}

hooks.addAction( 'all', 'reader_dev_helper', actionHandler, 1 );
hooks.addFilter( 'all', 'reader_dev_helper', filterHandler, 1 );

hooks.addAction( 'all', 'reader_dev_helper', actionHandler, 9999999 );
hooks.addFilter( 'all', 'reader_dev_helper', filterHandler, 9999999 );

export default hooks;
